import * as net from 'util/Net';

export interface CanvasDefinitionPreviewResponse {
  signedUrl: string;
  expiresAt: number;
}

export function getCanvasDefinitionPreviewUrl(
  canvasDefinitionId: string,
  filePath: string = 'index.html'
): Promise<CanvasDefinitionPreviewResponse> {
  return net.postJSONPromise({
    url: `/1/api/canvas-definitions/${canvasDefinitionId}:render`,
    data: {filePath},
  });
}
